module.exports = __webpack_public_path__ + "img/go-top.0641aa7f.svg";